module.exports = __webpack_public_path__ + "c21d31e0f37bde3b55a7b3e4ab51b7ba.png";